import { render, staticRenderFns } from "./IconSvgMEMAHHome.vue?vue&type=template&id=6bc3b906&scoped=true&"
import script from "./IconSvgMEMAHHome.vue?vue&type=script&lang=js&"
export * from "./IconSvgMEMAHHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc3b906",
  null
  
)

export default component.exports